// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sd-body.sd-container-modern,
.sv-header {
  overflow: visible !important;
}

.sd-header,
.sv-header,
.sv-header__content {
  width: 100vw !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}
.sv-header {
  padding: auto !important;
  background: #fff !important;
  border-bottom: 4px solid #2bbfa3 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 12px !important;
  height: 160px !important;
  margin-bottom: 32px !important;
}

.sv-header__title {
  color: #2bbfa3 !important;
  font-weight: 600 !important;
  font-size: 1.6rem !important;
  line-height: 1.3 !important;
  white-space: normal !important;
  margin: 0 !important;
  margin-bottom: 8px !important;
  text-align: center !important;
}

.sv-header__description {
  margin-top: -10px !important;
}
.sd-description,
.sv-string-viewer.sv-string-viewer--multiline {
  color: #6c757d !important;
  font-size: 1rem !important;
  line-height: 1.6 !important;
  white-space: pre-wrap !important;
  margin-top: 8px !important;
  margin-bottom: 8px !important;
  max-width: 1200px !important;
}

.sv-header__logo {
  max-height: 150px !important;
  object-fit: contain !important;
  display: block !important;
}

.sv-body__page {
  max-width: 900px !important;
  width: 100% !important;
  margin: 0 auto !important;
}

.sd-btn,
.sd-btn-action {
  background-color: #1ab394 !important;
  color: #fff !important;
  border: none !important;
  transition: background-color 0.2s ease-in-out;
}
.sd-btn:hover,
.sd-btn-action:hover {
  background-color: #159c82 !important;
}
.sd-rating__item-star--selected svg {
    stroke: rgba(0, 0, 0, 0);
    fill: #1ab394;
}
.sd-rating__item--selected {
    background-color: #1ab394;
}
.sd-file__choose-btn--text .sv-svg-icon {
  fill: #1ab394;
}
.sd-action {
  color: #1ab394;
}
.sd-rating__item-star--selected:not(.sd-rating__item-star--preview):focus-within svg {
  stroke: #1ab394;
  fill: #1ab394;
}
.sd-file__preview-item {
  width: calc(50% - 4px) !important;
  max-width: calc(50% - 4px) !important;
  min-height: 150px !important;
  overflow: hidden !important;
}
.sd-file__image-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  overflow: visible !important;
  height: 150px !important;
}
.sd-file__list {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  width: 100% !important;
  overflow-y: auto !important;
  max-height: 480px !important;
}
.sd-file__drag-area {
  width: 100% !important;
  max-width: 100% !important;
  overflow-y: auto !important;
  max-height: 500px !important;
  display: block !important;
}
.sd-file__image-wrapper video ~ .sd-file__remove-file-button,
.sd-file__image-wrapper iframe ~ .sd-file__remove-file-button {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/viewer.css"],"names":[],"mappings":";AACA;;EAEE,4BAA4B;AAC9B;;AAEA;;;EAGE,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2CAA2C;EAC3C,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;AAC/C;AACA;;EAEE,oCAAoC;AACtC;AACA;IACI,wBAAwB;IACxB,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;EAEE,wBAAwB;AAC1B","sourcesContent":["\n.sd-body.sd-container-modern,\n.sv-header {\n  overflow: visible !important;\n}\n\n.sd-header,\n.sv-header,\n.sv-header__content {\n  width: 100vw !important;\n  max-width: 100% !important;\n  box-sizing: border-box !important;\n}\n.sv-header {\n  padding: auto !important;\n  background: #fff !important;\n  border-bottom: 4px solid #2bbfa3 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  gap: 12px !important;\n  height: 160px !important;\n  margin-bottom: 32px !important;\n}\n\n.sv-header__title {\n  color: #2bbfa3 !important;\n  font-weight: 600 !important;\n  font-size: 1.6rem !important;\n  line-height: 1.3 !important;\n  white-space: normal !important;\n  margin: 0 !important;\n  margin-bottom: 8px !important;\n  text-align: center !important;\n}\n\n.sv-header__description {\n  margin-top: -10px !important;\n}\n.sd-description,\n.sv-string-viewer.sv-string-viewer--multiline {\n  color: #6c757d !important;\n  font-size: 1rem !important;\n  line-height: 1.6 !important;\n  white-space: pre-wrap !important;\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n  max-width: 1200px !important;\n}\n\n.sv-header__logo {\n  max-height: 150px !important;\n  object-fit: contain !important;\n  display: block !important;\n}\n\n.sv-body__page {\n  max-width: 900px !important;\n  width: 100% !important;\n  margin: 0 auto !important;\n}\n\n.sd-btn,\n.sd-btn-action {\n  background-color: #1ab394 !important;\n  color: #fff !important;\n  border: none !important;\n  transition: background-color 0.2s ease-in-out;\n}\n.sd-btn:hover,\n.sd-btn-action:hover {\n  background-color: #159c82 !important;\n}\n.sd-rating__item-star--selected svg {\n    stroke: rgba(0, 0, 0, 0);\n    fill: #1ab394;\n}\n.sd-rating__item--selected {\n    background-color: #1ab394;\n}\n.sd-file__choose-btn--text .sv-svg-icon {\n  fill: #1ab394;\n}\n.sd-action {\n  color: #1ab394;\n}\n.sd-rating__item-star--selected:not(.sd-rating__item-star--preview):focus-within svg {\n  stroke: #1ab394;\n  fill: #1ab394;\n}\n.sd-file__preview-item {\n  width: calc(50% - 4px) !important;\n  max-width: calc(50% - 4px) !important;\n  min-height: 150px !important;\n  overflow: hidden !important;\n}\n.sd-file__image-wrapper {\n  width: 100% !important;\n  max-width: 100% !important;\n  overflow: visible !important;\n  height: 150px !important;\n}\n.sd-file__list {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  gap: 8px !important;\n  width: 100% !important;\n  overflow-y: auto !important;\n  max-height: 480px !important;\n}\n.sd-file__drag-area {\n  width: 100% !important;\n  max-width: 100% !important;\n  overflow-y: auto !important;\n  max-height: 500px !important;\n  display: block !important;\n}\n.sd-file__image-wrapper video ~ .sd-file__remove-file-button,\n.sd-file__image-wrapper iframe ~ .sd-file__remove-file-button {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
